<mat-toolbar color="primary" class="toolbar-style" [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'">
  <!-- <span class="toolbar-header">Objektliste</span> -->
  <mat-form-field class="otSelection">
    <mat-select
      #otSelection
      [placeholder]="res.get('Table-SelectObjectType')"
      (selectionChange)="selectionChange(otSelection.value)"
      disableOptionCentering
    >
      @for (objectType of this.currentObjectSpaceObjectTypes; track objectType) {
        <mat-option [value]="objectType"> {{ objectType.displayText }}</mat-option>
      }
      @if (this.currentDataSets.length) {
        <mat-divider></mat-divider>
      }
      @for (objectType of this.currentDataSets; track objectType) {
        <mat-option [value]="objectType"> {{ objectType.displayText }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <span class="toolbar-spacer"></span>
  <button
    #searchMenuTrigger="matMenuTrigger"
    mat-icon-button
    [matMenuTriggerFor]="searchMenu"
    [disabled]="enableRefresh != true"
    class="bottomButton"
  >
    <mat-icon color="white" [svgIcon]="res.svgName('Search-Image')"></mat-icon>
  </button>
  <mat-menu #searchMenu="matMenu" class="searchMenu">
    <div class="searchFormField">
      <abcAutoCompleteInput
        [placeHolder]="res.get('Table-Search')"
        small="true"
        [items]="allAutocompleteItems"
        [panelBehaviour]="AutoCompletePanelBehaviour.OpenWhenTyping"
        (submit)="applyFilter($event)"
      >
      </abcAutoCompleteInput>
    </div>
  </mat-menu>
  <button
    id="selectObjectsButton"
    class="bottomButton"
    mat-icon-button
    [disabled]="enableRefresh != true"
    (click)="selectObjectsInMap()"
  >
    <mat-icon
      [svgIcon]="res.svgName('Locate-Image')"
      [ngClass]="enableRefresh != true ? 'gpsLocateButtonIconDisabled' : 'gpsLocateButtonIconEnabled'"
    ></mat-icon>
  </button>
  <button
    id="refreshButton"
    class="bottomButton"
    mat-icon-button
    [disabled]="enableRefresh != true"
    [matTooltip]="res.get('Table-ReloadData')"
    (click)="refreshTable()"
  >
    <mat-icon [svgIcon]="res.svgName('Refresh-Image')" class="bottomSheetButtonIcons"></mat-icon>
  </button>
  <button
    class="bottomButton"
    mat-icon-button
    [disabled]="enableRefresh != true"
    [matTooltip]="res.get('ColumnWidthModeChange')"
    (click)="this.toggleColumnAutoWidth()"
  >
    <mat-icon
      color="white"
      [svgIcon]="enableColumnAutoWidth ? res.svgName('ViewArray-Image') : res.svgName('ViewColumn-Image')"
    ></mat-icon>
  </button>
  <button mat-icon-button class="toolBarButton" (click)="this.frame.lib.closeBottomSheet()">
    <mat-icon [svgIcon]="res.svgName('ExpandMore-Image')"></mat-icon>
  </button>
</mat-toolbar>
<div
  *abcLet="{ tableState: tableState, dataSource: currentDataSource, hasGlobalFilters: hasGlobalFilters } as observables"
>
  @if (observables.tableState?.state === TableStateEnum.NoObjectType) {
    <div class="noDataPlaceHolder">&lt;{{ res.get('Table-NoObjectTypeSelected') }}&gt;</div>
  }
  @if (observables.tableState?.state === TableStateEnum.Loading) {
    <mat-spinner strokeWidth="3" [diameter]="50" class="objectTypeLoadProgressSpinner"></mat-spinner>
  }
  @if (observables.hasGlobalFilters) {
    <div style="height: 40px">
      <mat-chip-listbox>
        @for (filter of observables.dataSource?.filters; track filter) {
          <mat-chip (removed)="removeFilter(filter)">
            {{ filter.displayText }}
            <mat-icon [svgIcon]="res.svgName('Cancel-Image')" matChipRemove></mat-icon>
          </mat-chip>
        }
      </mat-chip-listbox>
    </div>
  }
  <div id="gridContainer">
    <abc-grid
      #abcGridTable
      (onCellPrepared)="onCellPrepared($event)"
      [repaintChangesOnly]="true"
      [columnAutoWidth]="enableColumnAutoWidth"
      [columnFixing]="{ enabled: true }"
      [setupDefaultLayoutOnInitialization]="true"
      [rtlEnabled]="currentLanguage === 'ar' ? undefined : false"
      [visible]="observables.tableState?.state === TableStateEnum.ObjectTypeLoaded"
      [autoNavigateToFocusedRow]="true"
      [autoFilterSelectedRows]="true"
      class="abc-grid-map-frame-table"
    >
    </abc-grid>
  </div>
  @if (observables.tableState?.state === TableStateEnum.Error) {
    <div>
      <br />
      <b>{{ res.get('Table-ErrorLoading') }}</b> {{ observables.tableState?.message }}
    </div>
  }
</div>
<div #objectsSets></div>
